import { useSiteInfo } from './useSiteInfo';

export interface SiteContact {
  /** A cég telefonszáma kiírásra (pl. „+36 30 339 2814"), vagy üres. */
  phone: string;
  /** `tel:` link szóközök és kötőjelek nélkül (pl. „tel:+36303392814"), vagy üres. */
  phoneHref: string;
  /** A cég e-mail címe, vagy üres. */
  email: string;
  /** `mailto:` link, vagy üres. */
  emailHref: string;
}

/** A telefonszámból `tel:` link: a szóközök és kötőjelek nélkül. Üres számra üres. */
export const toPhoneHref = (phone: string): string => {
  const digits = phone.replace(/[\s-]/g, '');
  return digits ? `tel:${digits}` : '';
};

/**
 * A cég elérhetősége (Webshop beállítások → `company_phone`, `company_email`).
 * Betöltés közben vagy üres beállításnál üres sztringeket ad — a hívó ilyenkor
 * egyszerűen nem rendereli a linket (sosem mutatunk helykitöltő adatot).
 */
export const useSiteContact = (): SiteContact => {
  const { data } = useSiteInfo();
  const phone = (data?.company_phone ?? '').trim();
  const email = (data?.company_email ?? '').trim();
  return {
    phone,
    phoneHref: toPhoneHref(phone),
    email,
    emailHref: email ? `mailto:${email}` : '',
  };
};
